import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import ElementUI from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import cnLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import jaLocale from 'element-ui/lib/locale/lang/ja'

import {
    setLang,
} from "@/utils/auth/";
Vue.use(VueI18n)
const messages = {
    en: {
        ...enLocale
    },
    CN: {
        ...cnLocale,
    },
    HK: {
        ...twLocale

    },
    ja: {
        ...jaLocale

    }
}
const i18n = new VueI18n({
    locale: 'zh-CN',
    fallbackLocale: "zh-CN",
    // messages,
    // silentTranslationWarn: true
    silentFallbackWarn: true,
    silentTranslationWarn: true,
    globalInjection: true,
    allowComposition: true,
})
Vue.use(ElementUI, {
    size: Cookies.get('size') || 'small',
    i18n: (key, value) => i18n.t(key, value)
})

let localLang = ''
export async function changeLange(val) {
    if (val) {
        if (val === 'zh-CN') {
            localLang = 'CN'
        } else if (val === 'zh-HK') {
            localLang = 'HK'
        } else if (val === 'en') {
            localLang = 'en'
        } else if (val === 'ja') {
            localLang = 'ja'
        }
        else {
            localLang = 'en'
            val = 'en'
        }
    }
    setLang(val);
    await loadLanguageAsync(val)
}
export function loadLanguageAsync(lang) {
    return import(`../assets/lang/${lang}`).then(msgs => {
        const temp = Object.assign(msgs.default, messages[localLang])
        i18n.setLocaleMessage(localLang, temp)
    })

}
export default i18n